import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: t, useRem: c, color: o, withColor: l, removeClassName: n, disableSSR: m, style: i, ...p }) => {
  const g = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-zhinengtiaocang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "32px-æºè½è°ä»"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: n ? "" : "normal",
        d: "M11.806 11.807a8.05 8.05 0 1 1 8.387 8.386 8.05 8.05 0 1 1-8.387-8.386Zm1.797.123a8.07 8.07 0 0 1 6.467 6.466 6.25 6.25 0 1 0-6.467-6.466Zm-.946 1.69a6.25 6.25 0 1 0 5.725 5.748l-.002-.02a6.26 6.26 0 0 0-5.723-5.728ZM4.15 6.1c0-1.074.876-1.95 1.95-1.95h2.85c1.749 0 2.585 2.109 1.386 3.327l-.005.005-2.849 2.849c-1.231 1.231-3.332.35-3.332-1.382V6.1Zm1.95-.25a.253.253 0 0 0-.25.25v2.849c0 .226.275.335.43.18l2.846-2.846a.245.245 0 0 0 .05-.278.263.263 0 0 0-.088-.115.23.23 0 0 0-.139-.04H6.1Zm21.752 17.201c0-1.732-2.101-2.613-3.332-1.382l-2.85 2.849-.004.005c-1.2 1.218-.363 3.327 1.387 3.327h2.849c1.074 0 1.95-.876 1.95-1.95v-2.849Zm-2.13-.18a.253.253 0 0 1 .43.18V25.9c0 .136-.115.25-.25.25h-2.85a.229.229 0 0 1-.227-.155.245.245 0 0 1 .051-.278l2.846-2.846Z",
        fillRule: "evenodd",
        fill: l ? r(o, 0, "#262933") : "#262933",
        datafollowfill: l ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, s = f;
export {
  s as default
};
